import { createBrowserRouter } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import { AppGateSplash } from "@/components/common/AppGateSplash";
import { hostModule, moduleRegistry, type ModuleInstance } from "@/modules";
import { AppRoot } from "./AppRoot";
import { buildModuleRoutes, buildRouteTree } from "./build-routes";
import { legacyRedirectRoutes } from "./legacy-redirects";
import { rootRoute, sharedRoutes } from "./shared-routes";

/**
 * Uygulama router'ı.
 *
 * Ana domain: tüm blueprint'li instance'lar kendi `basePath`'inde + shared
 * route'lar + legacy redirect'ler. `/` → AIModelsPage (geçici).
 *
 * Subdomain (`shop.chatharmony.ai`): yalnızca host instance'ı root'ta (`""`)
 * + shared route'lar + legacy redirect'ler. Shared `/` mount edilmez; host
 * modülünün index route'u `/`'ı alır.
 *
 * `status: "soon"` instance'ların route'ları da üretilir (flag ile açılıp
 * test edilebilsin); nav'da görünmezler — o karar Navigation'ın.
 */

const instanceRoutes = (instance: ModuleInstance): RouteObject[] => {
  if (!instance.blueprint) return [];
  const blueprint = moduleRegistry.getBlueprint(instance.blueprint);
  const ctx = { instance, params: instance.params };
  return buildModuleRoutes(instance, blueprint.routes(ctx));
};

const mountedInstances: ModuleInstance[] = hostModule
  ? [hostModule]
  : [...moduleRegistry.instances];

const moduleRoutes = mountedInstances.flatMap(instanceRoutes);

const flatRoutes: RouteObject[] = [
  ...(hostModule ? [] : [rootRoute]),
  ...moduleRoutes,
  ...legacyRedirectRoutes,
  ...sharedRoutes,
];

export const router = createBrowserRouter([
  {
    element: <AppRoot />,
    // Lazy modül chunk'ı ilk yüklemede çözülürken markalı splash
    HydrateFallback: AppGateSplash,
    children: buildRouteTree(flatRoutes),
  },
]);
